export default {"src":"/_next/static/media/fiche-toutou.b90ad9e1.svg","height":33,"width":32,"blurWidth":0,"blurHeight":0};